import { render, staticRenderFns } from "./register.vue?vue&type=template&id=d0ad23b6&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=d0ad23b6&prod&lang=scss&scoped=true"
import style1 from "./register.vue?vue&type=style&index=1&id=d0ad23b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ad23b6",
  null
  
)

export default component.exports